import { useState, useEffect } from "react";
import { useGetUserAccessQuery } from "src/services/UserRoleService";
const useUserAccess = () => {
    const [userAccess, setUserAccess] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetUserAccessQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setUserAccess(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { userAccess, isDataLoading };
};

export default useUserAccess;
